import {MdOutlineKeyboardBackspace} from "react-icons/md";
import {motion} from "framer-motion";
import {MdShoppingBasket} from "react-icons/md";
import {useStateValue} from "../../context/StateProvider";
import {hideCart} from "../../utils/functions";

const CartHeader = () => {
    const [{}, dispatch] = useStateValue();

    return (
        <div className="w-full flex items-center bg-primary justify-between p-4 cursor-pointer">
            <motion.div whileTap={{scale: 0.8}} onClick={() => hideCart(dispatch)}>
                <MdOutlineKeyboardBackspace className="text-textColor text-2xl "/>
            </motion.div>

            <div className="flex items-center justify-center gap-2">
                <p className="text-textColor">
                    Корзина
                </p>
            </div>
            <MdShoppingBasket className="text-xl cursor-pointer text-cartNumBg"/>
        </div>
    );
};

export default CartHeader;
